import Home from "./views/Home.vue";
import Acceso from "./views/auth/Acceso.vue";
import Login from "./views/auth/Login.vue";
import Registro from "./views/auth/Registro.vue";
import Cuenta from "./views/cuenta/Cuenta.vue";
import MiCuenta from "./views/cuenta/MiCuenta.vue";
import MisAmigos from "./views/cuenta/MisAmigos.vue";
import MisEntradas from "./views/MisEntradas.vue";
import PageNotFound from "./views/PageNotFound.vue";
import RegistroFinalizar from "./views/auth/RegistroFinalizar.vue";
import RegistroFinalizado from "./views/auth/RegistroFinalizado.vue";
import OlvidePassword from "./views/auth/OlvidePassword.vue";
import ResetearPassword from "./views/auth/ResetearPassword.vue";
import Espectaculo from "./views/espectaculo/Espectaculo.vue";
import Espectaculos from "./views/espectaculo/Espectaculos.vue";
// import Abonos from './views/espectaculo/Abonos.vue';
import PaseosGPC from "./views/espectaculo/PaseosGPC.vue";
import EspectaculoCompra from "./views/espectaculo/EspectaculoCompra.vue";
import EspectaculoCanjeFin from "./views/espectaculo/EspectaculoCanjeFin.vue";
import EspectaculoCompraFin from "./views/espectaculo/EspectaculoCompraFin.vue";
import EspectaculoTransferenciaFin from "./views/espectaculo/EspectaculoTransferenciaFin.vue";
import EspectaculoTransferenciaButaca from "./views/espectaculo/EspectaculoTransferenciaButaca.vue";
import PagoExitoso from "./views/espectaculo/PagoExitoso.vue";
import PagoExitosoPP from "./views/espectaculo/PagoExitosoPP.vue";
import Cortesia from "./views/espectaculo/Cortesia.vue";
import InvitacionPalco from "./views/espectaculo/InvitacionPalco.vue";
import ParkingPalco from "./views/espectaculo/ParkingPalco.vue";
import ParkingPalcoReserva from "./views/espectaculo/ParkingPalcoReserva.vue";
import ActualizarDatosNacional from "./views/auth/ActualizarDatosNacional.vue";
import RegistroMedio from "./views/medios/RegistroMedio.vue";
import AcreditacionMedio from "./views/medios/AcreditacionMedio.vue";
import MedioPrensaCanje from "./views/medios/MedioPrensaCanje.vue";
import Acreditacion from "./views/acreditacion/Acreditacion.vue";
import LinkPago from "./views/espectaculo/LinkPago.vue";

export const routes = [
	{
		path: "",
		name: "home",
		component: Home,
	},
	{
		path: "/acceso/:accesoToken",
		name: "acceso",
		component: Acceso,
	},
	{
		path: "/actualizar-datos",
		name: "actualizar-datos",
		component: ActualizarDatosNacional,
		meta: {
			requiresVisitor: true,
			hideHeaderFooter: true,
		},
	},
	{
		path: "/entrar",
		name: "login",
		component: Login,
		meta: {
			requiresVisitor: true,
			hideHeaderFooter: true,
		},
	},
	{
		path: "/registro",
		name: "registro",
		component: Registro,
		meta: {
			requiresVisitor: true,
			hideHeaderFooter: true,
		},
	},
	{
		path: "/registro-finalizar",
		name: "registro-finalizar",
		component: RegistroFinalizar,
		meta: {
			requiresVisitor: true,
			hideHeaderFooter: true,
		},
	},
	{
		path: "/registro-finalizado/:hashVerificacion",
		name: "registro-finalizado",
		component: RegistroFinalizado,
		meta: {
			requiresVisitor: true,
			hideHeaderFooter: true,
		},
	},
	{
		path: "/olvide-password",
		name: "olvide-password",
		component: OlvidePassword,
		meta: {
			requiresVisitor: true,
			hideHeaderFooter: true,
		},
	},
	{
		path: "/resetear-password/:hashVerificacion",
		name: "resetear-password",
		component: ResetearPassword,
		meta: {
			requiresVisitor: true,
			hideHeaderFooter: true,
		},
	},
	// {
	// 	path: '/mi-perfil',
	// 	name: 'perfil',
	// 	component: Perfil,
	// 	meta: {
	// 		requiresAuth: true
	// 	}
	// },
	{
		path: "/cuenta",
		// name: 'cuenta',
		component: Cuenta,
		children: [
			{
				// Mi perfil
				path: "/",
				name: "mi-cuenta",
				components: {
					cuenta: MiCuenta,
				},
			},
			{
				path: "mis-amigos",
				name: "mis-amigos",
				components: {
					cuenta: MisAmigos,
				},
			},
			{
				path: "mis-entradas",
				name: "mis-entradas",
				components: {
					cuenta: MisEntradas,
				},
				meta: {
					requiresAuth: true,
				},
			},
		],
	},
	{
		path: "/espectaculo/:espectaculoId",
		name: "espectaculo",
		component: Espectaculo,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: "/espectaculos",
		name: "espectaculos",
		component: Espectaculos,
	},
	// {
	// 	path: '/abonos',
	// 	name: 'abonos',
	// 	component: Abonos,
	// },
	{
		path: "/paseos-gpc",
		name: "paseos-gpc",
		component: PaseosGPC,
	},
	{
		path: "/espectaculo/:espectaculoId/comprar",
		name: "espectaculo-compra",
		component: EspectaculoCompra,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: "/espectaculo/:espectaculoId/transferencia-butaca",
		name: "espectaculo-transferencia-butaca",
		component: EspectaculoTransferenciaButaca,
		meta: {
			requiresAuth: true,
		},
	},
	{
		path: "/espectaculo/:espectaculoId/canje-finalizado",
		name: "espectaculo-canje-fin",
		component: EspectaculoCanjeFin,
		meta: {
			requiresAuth: true,
		},
		props: true,
	},
	{
		path: "/espectaculo/:espectaculoId/compra-finalizada",
		name: "espectaculo-compra-fin",
		component: EspectaculoCompraFin,
		meta: {
			requiresAuth: true,
		},
		props: true,
	},
	{
		path: "/pago-exitoso",
		name: "pago-exitoso",
		component: PagoExitoso,
		meta: {
			requiresAuth: true,
		},
		props: true,
	},
	{
		path: "/pago-exitoso-pp",
		name: "pago-exitoso-pp",
		component: PagoExitosoPP,
		// meta: {
		// 	requiresAuth: true
		// },
		props: true,
	},
	{
		path: "/espectaculo/:espectaculoId/transferencia-finalizada",
		name: "espectaculo-transferencia-fin",
		component: EspectaculoTransferenciaFin,
		meta: {
			requiresAuth: true,
		},
		props: true,
	},
	{
		path: "/cortesia/:espectaculoId/:cortesiaId/:cortesiaToken",
		name: "cortesia",
		component: Cortesia,
	},
	{
		path: "/link-pago/:espectaculoId/:linkPagoId/:linkPagoToken",
		name: "link-pago",
		component: LinkPago,
	},
	{
		path: "/palco/:espectaculoId/:tribunaId/:sectorCod/:palcoToken",
		name: "invitacion-palco",
		component: InvitacionPalco,
	},
	{
		path: "/parking/:espectaculoId/:tribunaId/:sectorCod/:palcoToken",
		name: "parking-palco",
		component: ParkingPalco,
	},
	{
		path: "/palco-reserva/:tribunaId/:sectorCod/:palcoToken",
		name: "parking-palco-reserva",
		component: ParkingPalcoReserva,
	},
	{
		path: "/prensa/registro",
		name: "registro-medio",
		component: RegistroMedio,
		meta: {
			requiresVisitor: true,
		},
	},
	{
		path: "/prensa/canje/:espectaculoId/:prensaMedioId/:espectaculoPrensaMedioToken",
		name: "medio-prensa-canje",
		component: MedioPrensaCanje,
		meta: {
			requiresVisitor: true,
		},
	},
	{
		path: "/prensa/:espectaculoId/acreditacion",
		name: "acreditacion-medio",
		component: AcreditacionMedio,
		meta: {
			requiresVisitor: true,
		},
	},
	{
		path: "/acreditacion/:espectaculoId",
		name: "acreditacion-general",
		component: Acreditacion,
		meta: {
			requiresVisitor: true,
		},
	},
	{
		path: "/404",
		name: "error",
		component: PageNotFound,
	},
	{
		path: "*",
		component: PageNotFound,
	},
];
